import React from 'react';
import { Drawer, Button, Card } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import { FormInput, FormPhoneInput } from '../../../../../../components/form';
import { useTranslation } from 'react-i18next';
import classes from '../../../../style/main.module.scss';

export const EditEntityDrawer = ({ isOpen, onClose, onSubmit, isSubmitting }) => {
    const { t } = useTranslation();

    return (
        <Drawer
            classNames={{
                root: classes.drawerRoot
            }}
            open={isOpen}
            onClose={onClose}
            header={
                <Drawer.Header
                    title={t('sauron.financeModule.entityOverview.editDrawer.title')}
                    subtitle={t('sauron.financeModule.entityOverview.editDrawer.subtitle')}
                    icon="file"
                    iconOffsets={[0, 1.5]}
                />
            }
            footer={
                <Drawer.Footer
                    actions={[
                        <Button as="button" key="cancel" onClick={onClose}>
                            {t('common.cta.cancel')}
                        </Button>,
                        <Button as="button" key="save" primary onClick={onSubmit} isLoading={isSubmitting}>
                            {t('sauron.financeModule.entityOverview.editDrawer.submitCta')}
                        </Button>
                    ]}
                />
            }
        >
            <Card>
                <Card.Header>
                    <Card.Title>{t('common.information')}</Card.Title>
                </Card.Header>
                <Card.Content>
                    <fieldset className={classes.fieldset}>
                        <legend className={classes.legend}>{t('sauron.financeModule.entityOverview.entity')}</legend>
                        <FormInput name="entityName" label={t('sauron.financeModule.entityOverview.terms.entityName')} required />
                    </fieldset>
                    <fieldset className={classes.fieldset}>
                        <legend className={classes.legend}>{t('sauron.financeModule.entityOverview.contact')}</legend>
                        <FormInput name="firstName" label={t('sauron.financeModule.entityOverview.fields.firstName')} />
                        <FormInput name="lastName" label={t('sauron.financeModule.entityOverview.fields.lastName')} />
                        <FormInput name="email" label={t('sauron.financeModule.entityOverview.fields.email')} required />
                        <FormPhoneInput name="phoneNumber" label={t('sauron.financeModule.entityOverview.fields.phoneNumber')} required />
                    </fieldset>
                </Card.Content>
            </Card>
        </Drawer>
    );
};

EditEntityDrawer.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    data: PropTypes.shape({
        entityName: PropTypes.string,
        ownerFirstName: PropTypes.string,
        ownerLastName: PropTypes.string,
        ownerEmail: PropTypes.string,
        ownerPhoneNumber: PropTypes.string
    }),
    onChangeField: PropTypes.func,
    onSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool
};
